<template>
    <div class="lms__user_achievements_edit_details">
        <form-text
            :name="'lms-user-achievements-name'"
            :label="$t('lms.user.achievements.labels.name')"
            :required="true"
            :v-validate="'required|max:200'"
            :data-vv-as="$t('forms.dataVvAs.name')"
            v-model="achievementName"
        />
        <form-textarea
            :label="$t('lms.user.achievements.labels.description')"
            :name="'lms-user-achievements-description'"
            :v-validate="'max:255'"
            v-model="achievementDescription"
        />
        <form-checkbox
            :disabled="!achievementRules"
            :label="'Status'"
            :name="'lms-user-achievements-status'"
            :switcher="true"
            :value="achievementStatus === 'active'"
            @input="updateAchievementStatusUpload"
        ></form-checkbox>
        <form-submit
            @reset="performReset"
            @submit="performSubmitValidate"
            :reset-button-text="$t('lms.user.achievements.buttons.resetChanges')"
            :submit-button-text="$t('lms.user.achievements.buttons.saveChanges')"
        />
        <pop-notify
            ref="popnotifyvalidation"
            :class="'pop__notify--validation'"
            :title-text="`Something's not quite right`"
            :content-text="'Please check that you have filled out all the fields in the form correctly and try again.'"
            :cancel-button-text="'Ok'"
            :submit-button-active="false"
        />
    </div>
</template>

<script>
import FormText from '@/components/default/forms/FormText'
import FormTextarea from '@/components/default/forms/FormTextarea'
import FormSubmit from '@/components/default/forms/FormSubmit'
import FormCheckbox from '@/components/default/forms/FormCheckbox'
import { performReset, performSubmitValidate, validateBeforeRouteLeave, watchContentChangeEmit } from '@/helpers/mixins'
import PopNotify from '@/components/default/shared/PopNotify'

export default {
  name: 'lms-user-achievements-edit-details',
  components: {
    PopNotify,
    FormText,
    FormTextarea,
    FormSubmit,
    FormCheckbox
  },
  mixins: [validateBeforeRouteLeave, performReset, performSubmitValidate, watchContentChangeEmit],
  computed: {
    achievementName: {
      get () {
        return this.$store.getters.getLmsUserAchievementName
      },
      set (value) {
        this.$store.dispatch('lmsUserAchievementSetName', value)
      }
    },
    achievementDescription: {
      get () {
        return this.$store.getters.getLmsUserAchievementDescription
      },
      set (value) {
        this.$store.dispatch('lmsUserAchievementSetDescription', value)
      }
    },
    achievementStatus: {
      get () {
        return this.$store.getters.getLmsUserAchievementStatus
      },
      set (value) {
        this.$store.dispatch('lmsUserAchievementSetStatus', value)
      }
    },
    achievementRules: {
      get () {
        return this.$store.getters.getLmsUserAchievementRule
      }
    },
    //
    watchContent () {
      return this.achievementName + this.achievementDescription + this.achievementStatus
    },
    //
    rootItemName () {
      return 'achievement'
    },
    nameActionCreate () {
      return 'lmsUserAchievementCreate'
    },
    nameActionUpdate () {
      return 'lmsUserAchievementUpdate'
    },
    nameActionReset () {
      return 'lmsUserAchievementReset'
    }
  },
  methods: {
    updateAchievementStatusUpload (value) {
      let status = value ? 'active' : 'draft'
      this.$store.dispatch('lmsUserAchievementSetStatus', status)
    }
  },
  provide () {
    return {
      $validator: this.$validator
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/user/achievements/_lmsuserachievementseditdetails";
</style>
